var qty_total = 70;
var qty_left = 13;

function submitDocumentation(id) {
//   alert(`id ${id}`);
  $("#docFrame").removeClass("hide");
  $("#docFrame").attr("src", `https://shugs-service.uc.r.appspot.com/tax/entityPicker/${id}`);
}

$( document ).ready(function() {
  	disabledAdds();
    update_dozen();
  	
  	$('#max-order').hide();
 	$("#max-order").css({opacity:1})
  
    $('#inputqty_dozen').on('input', function(){
      update_dozen();
  	});
  
    $(document).on("click", ".primary-input span", function(){
      update_dozen();
    });
  
  	$('.div-list-product .js--num').on('input', function(){
      update_dozenItem(this, 'input');
  	});
  
  	$(document).on("click", ".div-list-product span", function(){
      update_dozenItem(this, 'span');
    });

  $('#list_freezer').slick({
      //centerMode: true,
      centerPadding: '5px',
      arrows: true,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 819,
          settings: {
            arrows: true,
            //centerMode: true,
            centerPadding: '10px',
            slidesToShow: 3
          }
        },{
          breakpoint: 619,
          settings: {
            arrows: true,
            //centerMode: true,
            centerPadding: '10px',
            slidesToShow: 2
          }
        },
        {
          breakpoint: 419,
          settings: {
            arrows: true,
            //centerMode: true,
            centerPadding: '25px',
            slidesToShow: 1
          }
        }
      ]
    });
  
    $('#list_creams').slick({
      //centerMode: true,
      centerPadding: '5px',
      arrows: true,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 819,
          settings: {
            arrows: true,
            //centerMode: true,
            centerPadding: '10px',
            slidesToShow: 3
          }
        },{
          breakpoint: 619,
          settings: {
            arrows: true,
            //centerMode: true,
            centerPadding: '10px',
            slidesToShow: 2
          }
        },
        {
          breakpoint: 419,
          settings: {
            arrows: true,
            //centerMode: true,
            centerPadding: '25px',
            slidesToShow: 1
          }
        }
      ]
    });
  
  	$('#list_toppings').slick({
      //centerMode: true,
      centerPadding: '5px',
      arrows: true,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 819,
          settings: {
            arrows: true,
            //centerMode: true,
            centerPadding: '10px',
            slidesToShow: 3
          }
        },{
          breakpoint: 619,
          settings: {
            arrows: true,
            //centerMode: true,
            centerPadding: '10px',
            slidesToShow: 2
          }
        },
        {
          breakpoint: 419,
          settings: {
            arrows: true,
            //centerMode: true,
            centerPadding: '25px',
            slidesToShow: 1
          }
        }
      ]
    });
  	$('#list_coffee').slick({
      //centerMode: true,
      centerPadding: '5px',
      arrows: true,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 819,
          settings: {
            arrows: true,
            //centerMode: true,
            centerPadding: '10px',
            slidesToShow: 3
          }
        },{
          breakpoint: 619,
          settings: {
            arrows: true,
            //centerMode: true,
            centerPadding: '10px',
            slidesToShow: 2
          }
        },
        {
          breakpoint: 419,
          settings: {
            arrows: true,
            //centerMode: true,
            centerPadding: '25px',
            slidesToShow: 1
          }
        }
      ]
    });
    $('#list_lox').slick({
      //centerMode: true,
      centerPadding: '5px',
      arrows: true,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 819,
          settings: {
            arrows: true,
            //centerMode: true,
            centerPadding: '10px',
            slidesToShow: 3
          }
        },{
          breakpoint: 619,
          settings: {
            arrows: true,
            //centerMode: true,
            centerPadding: '10px',
            slidesToShow: 2
          }
        },
        {
          breakpoint: 419,
          settings: {
            arrows: true,
            //centerMode: true,
            centerPadding: '25px',
            slidesToShow: 1
          }
        }
      ]
    });
});


// code from DEV

// $( "input[type=text]" ).val(function( index, value ) {
//   alert(value);
// });
setTimeout(function(){
  //$("#qty-0").on("change paste keyup", function() {$(this).val($(this).val().replace(/\./g,""));}); old method. works, not as well.
  $(".js--num").attr("oninput", "noDecimal(this)");
}, 1000);

function noDecimal(obj) {
  obj.value = Math.round(obj.value);
}
    
// end code


function update_dozen(){
//     $("#inputqty_dozen").val($("#inputqty_dozen").val().replace(".", ""));
//    	dozen_total = $("#inputqty_dozen").val();
  
//   if (dozen_total < 3) {
//     // MINIMUM ORDER 3 DOZEN
//     dozen_total = 3;
//     qty_total = 3*13;
//     $("#inputqty_dozen").val(3);
//   }  
//   if (dozen_total > 15) {
//     // tell users to email info@shugsbagels.com
//     $('#max-order').show();
//     dozen_total = 15;
//     qty_total = 15*13;
//     $("#inputqty_dozen").val(15);
//   }
//   else if (dozen_total <= 9) {
//     $('#max-order').hide();
//   }
  
//   if(dozen_total>0){
//     qty_total = dozen_total * 13;
//   	$("#qty-total").text("You'll get a total of " + (qty_total) + " bagels");
//   	$(".qty-left").text("You have "+(qty_total)+" bagels left to choose");
//   }else{
//     $("#inputqty_dozen").val(1);
//   }
  	
}

function update_dozenItem(item, validator){
  var limit = $("#list-length").val();
  var data_qty = 0;
  var subtotal = 0;
  
//   alert("limit = " + limit);
  
  for(var x = 0; x<limit; x++){
    var val = ($("#qty-"+x).val()*1);
    subtotal = subtotal + val;
    // NO LONGER NEED CAP UNITS TO DOZEN
//     if(subtotal > qty_total){
//       var over = subtotal - qty_total;
//       if(validator == "input"){
//         data_qty = $(item).val()*1;
//         $(item).val(data_qty-over);
//          subtotal = subtotal - over ;
//       }else{
//         data_qty =  $(item).prev('input').val()*1;
//         $(item).prev('input').val(data_qty-over);
//         subtotal = subtotal - over ;
//       }
//     }
  }
  
//   alert("qty_total = " + qty_total);
  
  qty_left = qty_total-subtotal;
  
  // dealing with no plural
  if (subtotal == 1) $("#qty-total").text("You'll get a total of " + (subtotal) + " bagel");
  else $("#qty-total").text("You'll get a total of " + (subtotal) + " bagels");
  
  
  if(qty_left >= 0){
    $(".qty-left").text("You need "+(qty_left)+" more bagels to meet the minimum order.");
  }
  
  if(qty_left <= 0){
    $(".qty-left").text("You have met the minimum order requirements.");
    
    // check to see if the user is order A LOT of bagels
//     if (subtotal > 200) {
//       $('#max-order').show();
//     }							// No longer having a maximum.
//     else {
//       $('#max-order').hide();
//     }
    
    // this is by the developer, so if something screws up, it's probably this
	// goal: clear the cart every time a user places a new order

    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      success: function(){
        //console.log("cart cleared");
      },
      dataType: 'json'
    });

	// END
    // line commented out below bc it was used to "cap" orders at n dozens, where
    // each dozen has 13 bagels
    //$('.div-list-product .js--add').css({"cursor": "not-allowed","opacity":"0.4"});
    enabledAdds();
    $("#button_addToCart").attr("disabled",false);
  }else{
    $('.div-list-product .js--add').css({"background-color": "transparent", "cursor": "pointer","opacity":"1"});
    disabledAdds();
    $("#button_addToCart").attr("disabled",true);
  }
   $('.primary-input .js--add').css({"background-color": "transparent", "cursor": "pointer"});
}

function disabledAdds(){
  $('.div_list_item .js--num').addClass("div_off");
  $('.div_list_item .js--add').addClass("div_off");
  $('.div_list_item .js--minus').addClass("div_off");
}

function enabledAdds(){
  $('.div_list_item .js--num').removeClass("div_off");
  $('.div_list_item .js--add').removeClass("div_off");
  $('.div_list_item .js--minus').removeClass("div_off");
}

$(document).on("click", "#button_addToCart", function(){
   var limit = $("#list-length").val();
   var list_items = [];

   for(var x = 0; x<limit; x++){
         var qty = ($("#qty-"+x).val()*1);
         var product_id = $("#list-"+x).val();
         if(qty > 0){
//            alert("line 226 triggered");
            var data_item = {
               'quantity': qty,
               'id': product_id,
            }             
            list_items.push(data_item);
          }
   }
  
   var creams = $("#list_creams .div_list_item")
   for(var x = 0; x<creams.length; x++){
         var qty = ($(creams[x]).find("input").val()*1);
         if(qty > 0){
           	var product_id = $(creams[x]).find("select").val();
            var data_item = {
               'quantity': qty,
               'id': product_id,
            }             
            list_items.push(data_item);
          }
   }
  
   var toppings = $("#list_toppings .div_list_item")
   for(var x = 0; x<toppings.length; x++){
         var qty = ($(toppings[x]).find("input").val()*1);
         if(qty > 0){
           	var product_id = $(toppings[x]).find("select").val();
            var data_item = {
               'quantity': qty,
               'id': product_id,
            }             
            list_items.push(data_item);
          }
   }
  
  
   var coffees = $("#list_coffee .div_list_item")
   for(var x = 0; x<coffees.length; x++){
         var qty = ($(coffees[x]).find("input").val()*1);
         if(qty > 0){
           	var product_id = $(coffees[x]).find("select").val();
            var data_item = {
               'quantity': qty,
               'id': product_id,
            }             
            list_items.push(data_item);
          }
   }
  
   var lox = $("#list_lox .div_list_item")
   for(var x = 0; x<lox.length; x++){
         var qty = ($(lox[x]).find("input").val()*1);
         if(qty > 0){
           	var product_id = $(lox[x]).find("select").val();
            var data_item = {
               'quantity': qty,
               'id': product_id,
            }             
            list_items.push(data_item);
          }
   }
  
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: {"items":list_items},
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        //callback(line_item, form);
        location.href = "/cart";
      }
      else {
        location.href = "/cart";
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
        console.log("Error function");
      }
      else {
        console.log("Error true");
      }
    }
  };
  jQuery.ajax(params);
});
